import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query FetchArticles($page: Int!, $limit: Int!, $sort: String) {
    Articles(page: $page, limit: $limit, sort: $sort) {
      page
      totalPages
      totalDocs
      docs {
        id
        title
        shortDescription
        featuredImage {
          url
          alt
        }
        primaryCategory {
          id
          name
          slug
        }
        slug
      }
    }
  }
`

export enum ArticleSort {
  CreatedAtAsc = 'createdAt',
  CreatedAtDesc = '-createdAt',
}

export interface ArticlesQueryInput {
  page: number
  limit: number
  sort?: ArticleSort
}

export interface ArticlesQueryOutput {
  Articles: {
    page: number
    totalPages: number
    totalDocs: number
    docs: {
      id: string
      title: string
      shortDescription: string
      featuredImage: {
        url: string
        alt: string
      }
      primaryCategory: {
        id: string
        name: string
        slug: string
      }
      slug: string
    }[]
  }
}

const defaultVariables = {
  page: 1,
  limit: 6,
  sort: ArticleSort.CreatedAtDesc,
}

export const useArticlesQuery = (
  input: ArticlesQueryInput,
  options?: QueryHookOptions<ArticlesQueryOutput, ArticlesQueryInput>
) =>
  usePersistedCacheQuery<ArticlesQueryOutput, ArticlesQueryInput>(query, {
    variables: input,
    ...options,
  })

export const fetchArticlesQuery = { query, defaultVariables }
